import { Configuration, LogLevel, PopupRequest } from "@azure/msal-browser";

// Single source of truth: read from environment variables
// These are injected at build time by Vite from .env files
const ENTRA_CLIENT_ID = import.meta.env.VITE_ENTRA_CLIENT_ID;
const ENTRA_AUTHORITY = import.meta.env.VITE_ENTRA_AUTHORITY;

if (!ENTRA_CLIENT_ID) {
  throw new Error("VITE_ENTRA_CLIENT_ID environment variable is required");
}
if (!ENTRA_AUTHORITY) {
  throw new Error("VITE_ENTRA_AUTHORITY environment variable is required");
}

export const msalConfig: Configuration = {
  auth: {
    clientId: ENTRA_CLIENT_ID,
    authority: ENTRA_AUTHORITY,
    redirectUri: window.location.origin + "/Login",
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
    },
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
};
